import { render, staticRenderFns } from "./sDataBanckingView.vue?vue&type=template&id=c8ef060c"
import script from "./sDataBanckingView.vue?vue&type=script&lang=js"
export * from "./sDataBanckingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports